import { motion, useInView } from "framer-motion"
import { graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useMemo, useRef, useState } from "react"
import Modal from "react-modal"
import { Autoplay, Navigation } from "swiper"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"
import ImageOpt from "./../ImageOpt"

const BrandListing = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade2 = {
    hidden: { opacity: 0, y: 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.75,
        staggerChildren: 0.4,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const data = useStaticQuery(graphql/* GraphQL */ `
    query WpBrands {
      brands: allWpBrand(sort: { title: ASC }) {
        edges {
          node {
          id
          title
          content
          excerpt
          brandContent {
            brandGallery {
              mediaItemUrl
            }
          }
          brandCategories {
            nodes {
              id
              name
            }
          }
          featuredImage {
            node {
              mediaItemUrl
              altText
            }
          }
          }
        }
      }
      category: allWpBrandCategory {
        edges {
          node {
            name
          }
        }
      }
    }
  `);

  const [tabOption, setTabOption] = useState("all")

  const brands = data.brands.edges.map(brand => brand.node);
  const categories = data.category.edges.map(category => category.node);

  const pageSize = 6
  const [itemsToDisplay, setItemsToDisplay] = useState(categories.map(() => pageSize));
  const [itemsToDisplay1, setItemsToDisplay1] = useState(pageSize)
  
  const allCatarray = useMemo(() => {
    const catArray = {};
  
    // Initialize 'all' category array
    catArray["all"] = [];
  
    // Iterate over brands and push all brands into the 'all' category
    brands.forEach(brand => {
      catArray["all"].push(brand);
    });
  
    return catArray;
  }, [brands]);

  const newCatarray = useMemo(() => {
    const catArray = {};
  
    // Initialize category arrays
    categories.forEach(category => {
      catArray[category.name] = [];
    });
  
    // Iterate over brands and push brands into their respective category arrays
    brands.forEach(brand => {
      brand.brandCategories.nodes.forEach(categoryNode => {
        const brandCategory = categoryNode.name;
        if (brandCategory) {
          if (!catArray[brandCategory]) {
            catArray[brandCategory] = []; // Initialize the category array if it doesn't exist
          }
          catArray[brandCategory].push(brand); // Push the brand to the category array
        }
      });
    });
  
    return catArray;
  }, [brands, categories]);

  const onLoadMore = i => {
    let temp = [...itemsToDisplay]
    temp[i] = temp[i] + pageSize
    setItemsToDisplay(temp)
  }

  const onallLoadMore = () => {
    setItemsToDisplay1(itemsToDisplay1 + pageSize)
  }

  const [modalIsOpen, setIsOpen] = React.useState(false)
  const [modalData, setModalData] = React.useState(false)

  function openModal(data) {
    setModalData(data)
    document.body.classList.add("modal-open")
    document.body.classList.add("micro-site")
    setIsOpen(true)
  }

  function closeModal() {
    document.body.classList.remove("modal-open")
    document.body.classList.remove("micro-site")
    setIsOpen(false)
  }

  const zigzagmodal = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0",
      border: "0",
      borderRadius: "0",
      width: "100%",
      height: "100%",
      backgroundColor: "#FFFFFF",
    },
    overlay: {
      zIndex: "99",
    },
  }

  const swiperRef = useRef(null)

  const handleNextClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slideNext()
  }
  const handlePrevClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slidePrev()
  }

  if (module.hideSection === "no") {
    return (
      <section
        className={`brnad-listing ${
          module.extraClass ? ` ${module.extraClass}` : ""
        }`}
        id={module.extraId}
      >
        <div className="container-fluid">
          <div className="bg-white-100 py-60 lgscreen:py-30 lgscreen:pb-30">
            <motion.div
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
            >
              <motion.div
                ref={ref}
                initial="hidden"
                animate={isInView || hasPlayed ? "show" : "hidden"}
                variants={sectionShow}
              >
                <div className="top-content relative w-full max-w-[960px] px-20 mx-auto text-center">
                  {module?.heading && (
                    <motion.h2 variants={animFade}>{module.heading}</motion.h2>
                  )}
                  {module?.description && (
                    <motion.div variants={animFade} className="content pb-30">
                      {parse(module.description)}
                    </motion.div>
                  )}
                </div>
                <div className="tabs-horizontal">
                  <motion.div variants={animFade}>
                    <ul className="tabs w-full flex flex-wrap justify-center mt-50 lgscreen:mt-30 gap-x-8 gap-y-5">
                      <li
                        onClick={() => {
                          setTabOption("all")
                        }}
                        onKeyDown={() => {
                          setTabOption("all")
                        }}
                        aria-hidden="true"
                        className={`tab-link cursor-pointer text-18 tracking-05em uppercase opacity-50  ${
                          tabOption === "all" ? "tab-current" : ""
                        }`}
                      >
                        All
                      </li>
                      {categories.map((item, i) => (
                          <li
                            key={i}
                            onClick={() => {
                              setTabOption(item.name)
                              setIsOpen(false)
                            }}
                            className={`tab-link cursor-pointer text-18 tracking-05em uppercase opacity-50  ${
                              tabOption === item.name
                                ? "tab-current"
                                : ""
                            }`}
                            data-tab={item.name}
                            onKeyDown={() => {
                              setTabOption(item.name)
                              setIsOpen(false)
                            }}
                            aria-hidden="true"
                          >
                            {item.name}
                          </li>
                        ))}
                    </ul>
                  </motion.div>
                </div>
                <div className="accordian-container mt-50 lgscreen:mt-25 px-80 lgscreen:px-40 mdscreen:px-20 relative">
                  <div
                    id="all"
                    className={`tab-content ${
                      tabOption === "all" ? "tab-current" : "hidden"
                    }`}
                  >
                    <div className="flex flex-wrap mt-50 lgscreen:mt-30 -mx-20 lgscreen:mx-0 gap-y-[75px] lgscreen:gap-y-[50px] mdscreen:gap-y-[25px]">
                      {allCatarray["all"]?.length > 0 &&
                        allCatarray["all"]
                          .slice(0, itemsToDisplay1)
                          .map((item, index) => (
                            <div
                              className="lg:w-4/12 w-full px-20 lgscreen:px-0"
                              key={index}
                            >
                              <motion.div
                                variants={animFade2}
                                className="category-bx"
                                onClick={() => {
                                  openModal(item);
                                }}
                              >
                                {item?.featuredImage && (
                                  <div className="img relative">
                                    <div
                                      onClick={(e) => {
                                        // Prevent the click event from propagating to the parent div
                                        e.stopPropagation();
                                        openModal(item);
                                      }}
                                    >
                                      <ImageOpt
                                        imgData={item.featuredImage.node.mediaItemUrl}
                                        width={1000}
                                        height={1000}
                                        imgAlt={item.featuredImage.node.altText}
                                        imgLoad="lazy"
                                        imgClass="object-cover"
                                      />
                                    </div>
                                  </div>
                                )}
                                <div className="category-content pt-25 pr-20 lgscreen:pr-0">
                                  {item?.title && (
                                    <h4
                                      onClick={(e) => {
                                        // Prevent the click event from propagating to the parent div
                                        e.stopPropagation();
                                        openModal(item);
                                      }}
                                    >
                                      {item.title}
                                    </h4>
                                  )}
                                  {item?.excerpt && (
                                    <div className="content w-full pr-30 pt-10">
                                      {parse(item.excerpt)}
                                    </div>
                                  )}
                                  <div className="flex flex-wrap gap-x-2 mt-25 gap-y-2">
                                    <button className="btn btn-border">read more</button>
                                  </div>
                                </div>
                              </motion.div>
                            </div>
                          ))}
                    </div>

                    {allCatarray["all"]?.length > 0 &&
                      allCatarray["all"]?.length > itemsToDisplay1 && (
                        <motion.div
                          variants={animFade}
                          className="flex flex-wrap justify-center mt-75 lgscreen:mt-35"
                        >
                          <button
                            onClick={onallLoadMore}
                            className="btn btn-border opacity-50"
                            onKeyDown={onallLoadMore}
                            aria-hidden="true"
                          >
                            load more
                          </button>
                        </motion.div>
                      )}
                  </div>
                  {categories.length > 0 &&
                    categories.map((item, i) => (
                      <div
                        key={i}
                        id={item.name}
                        className={`tab-content ${
                          tabOption === item.name
                            ? "tab-current"
                            : "hidden"
                        }`}
                      >
                        <div className="flex flex-wrap mt-50 lgscreen:mt-30 -mx-20 lgscreen:mx-0 gap-y-[120px] lgscreen:gap-y-[50px] mdscreen:gap-y-[25px]">
                          {newCatarray[`${item.name}`]?.length > 0 &&
                            newCatarray[`${item.name}`]
                              .slice(0, itemsToDisplay[i] || pageSize)
                              .map((item, j) => (
                                <div
                                  className="lg:w-4/12 w-full px-20 lgscreen:px-0"
                                  key={j}
                                >
                                  <motion.div
                                    variants={animFade2}
                                    className="category-bx"
                                  >
                                    {item?.featuredImage && (
                                      <div className="img relative">
                                        <ImageOpt
                                          imgData={item.featuredImage.node.mediaItemUrl}
                                          width={1000}
                                          height={1000}
                                          imgAlt={item.featuredImage.node.altText}
                                          imgLoad="lazy"
                                        />
                                      </div>
                                    )}
                                    <div className="category-content pt-25 pr-20">
                                      {item?.title && <h4>{item.title}</h4>}
                                      {item?.excerpt && (
                                        <div className="content w-full pr-30">
                                          {parse(item.excerpt)}
                                        </div>
                                      )}
                                      <div className="flex flex-wrap gap-x-2 mt-25 gap-y-2">
                                        <button
                                          className="btn btn-border"
                                          onClick={() => {
                                            openModal(item)
                                          }}
                                        >
                                          read more
                                        </button>
                                      </div>
                                    </div>
                                  </motion.div>
                                </div>
                              ))}
                        </div>
                        {newCatarray[`${item.name}`]?.length > 0 &&
                          newCatarray[`${item.name}`]?.length >
                            (itemsToDisplay[i] || pageSize) && (
                            <div className="flex flex-wrap justify-center mt-75 lgscreen:mt-35">
                              <button
                                onClick={() => {
                                  onLoadMore(i)
                                }}
                                className="btn btn-border opacity-50"
                                onKeyDown={() => onLoadMore(i)}
                                aria-hidden="true"
                              >
                                load more
                              </button>
                            </div>
                          )}
                      </div>
                    ))}
                </div>

                {modalData && (
                  <Modal
                    isOpen={modalIsOpen}
                    style={zigzagmodal}
                    onRequestClose={closeModal}
                    contentLabel="Example Modal"
                    ariaHideApp={false}
                    id="whatson-details"
                  >
                    <div
                      variants={animFade}
                      className="zigzag-modal-popup h-full"
                    >
                      <motion.div variants={animFade}>
                        <button
                          onClick={closeModal}
                          className="absolute right-70 top-45 z-9 lgscreen:right-30 lgscreen:top-30 lgscreen:bg-white-100 lgscreen:rounded-100  flex items-center justify-center w-[42px] h-[42px] rounded-100"
                        >
                          <img
                            src="../../../images/close.svg"
                            className="lgscreen:w-10"
                            width={15}
                            height={15}
                            loading="lazy"
                            alt="Close"
                          />
                        </button>
                      </motion.div>
                      <div className="flex flex-wrap items-center h-full">
                        {modalData?.brandContent.brandGallery.length > 0 && (
                          <div className="lg:w-5/12 w-full h-full mdscreen:h-auto relative">
                            <Swiper
                              ref={swiperRef}
                              spaceBetween={30}
                              loop={true}
                              slidesPerView={"1"}
                              speed={1500}
                              autoplay={{
                                delay: 2000,
                                disableOnInteraction: false,
                              }}
                              pagination={{ clickable: false }}
                              breakpoints={{
                                0: { slidesPerView: 1 },
                                641: { slidesPerView: 1 },
                                1024: { slidesPerView: 1 },
                              }}
                              modules={[Autoplay, Navigation]}
                            >
                              {modalData.brandContent.brandGallery.map((img, l) => (
                                <SwiperSlide key={l}>
                                  <div className="img h-full">
                                    <ImageOpt
                                      imgData={img.mediaItemUrl}
                                      imgAlt={img.altText}
                                      imgClass="w-full h-screen lgscreen:h-full object-cover"
                                      width={2040}
                                      height={2301}
                                      imgLoad="lazy"
                                    />
                                  </div>
                                </SwiperSlide>
                              ))}
                            </Swiper>
                            <div className="swiper-arrow arrow-big flex gap-x-5">
                              <button
                                className="absolute left-25 lgscreen:left-20 top-50per translate-y-minus_50 z-9 transition-all duration-300 outline-none"
                                onClick={() =>
                                  handlePrevClick(`.zigzag-modal-popup .swiper`)
                                }
                              >
                                <img
                                  src="../../../images/micro-slider-arrow.svg"
                                  width={42}
                                  height={42}
                                  loading="lazy"
                                  alt="Arrow"
                                />
                              </button>
                              <button
                                className="absolute right-25 lgscreen:right-20 top-50per translate-y-minus_50 z-9 transition-all duration-300 outline-none"
                                onClick={() =>
                                  handleNextClick(
                                    `.zigzag-modal-popup .swiper `
                                  )
                                }
                              >
                                <img
                                  src="../../../images/micro-slider-arrow.svg"
                                  width={42}
                                  height={42}
                                  className="scale-x-[-1]"
                                  loading="lazy"
                                  alt="Arrow"
                                />
                              </button>
                            </div>
                          </div>
                        )}
                        <div className="lg:w-7/12 w-full">
                          <div className="px-100 laptop:px-50 lgscreen:px-20 lgscreen:py-30">
                            {modalData?.title && (
                              <motion.h3 variants={animFade}>
                                {modalData.title}
                              </motion.h3>
                            )}
                            {modalData?.content && (
                              <motion.div
                                variants={animFade}
                                className="content pt-15"
                              >
                                {parse(modalData.content)}
                              </motion.div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal>
                )}
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>
    )
  }
  return null
}

export default BrandListing
export const EatDrinkBrandListingFragment = graphql`
  fragment EatDrinkBrandListingFragment on WpEatDrink_Restaurantcontent_RestaurantContent_BrandListing {
    extraId
    extraClass
    hideSection
    heading
    description
    brandTab {
      brandCategory
      brandBox {
        heading
        shortDescription
        image {
          altText
          mediaItemUrl
        }
        popupDescription
        popupImages {
          image {
            altText
            mediaItemUrl
          }
        }
      }
    }
  }
`
